import '../partials/bootstrap'
import '../controllers/search_controller'
import '../controllers/email_input_controller'
import '../vendor/cookies';
